import { useEffect, useState } from "react";

import QuickTable from "components/Meta/QuickTable";
import Form from "components/MeForm/Form";
import proxy from "api/proxy";
import { signal } from "@preact/signals-react";
import useMainStore from "store/mainStore";
import { useWizardStore } from "store/wizardStore";
import { getStorage } from "store/local";

const ctxView = {
  model: "hotel.booking.update_taxes.start",
  selectable: false, // options: multi - one - false
  limit: null,
  form_action: ["open"],
  table_action: ["open"],
  webfields: {
    taxes: { type: "selection", options: [] },
    accept: {
      type: "button",
      method: "handleAccept",
      onSuccessMsg: "Taxes updated!",
      color: "blue",
    },
  },
  webform: [{ name: "taxes" }, { name: "accept" }],
  webtree: [],
};

const getAmount = (record) => {
  if (record.unit_price_w_tax && record.quantity) {
    const amount = (record.unit_price_w_tax * record.quantity).toFixed(2);
    return amount;
  }
};

const ctxViewCharges = {
  model: "hotel.folio.charge",
  form_action: [],
  table_action: [],
  domain: [],
  orderBy: [["sale_date", "ASC"]],
  limit: 100,
  selectable: "multi",
  target: "folio",
  webfields: {
    sale_date: {
      type: "date",
      required: true,
      readOnly: true,
    },
    kind: {
      type: "selection",
      readOnly: true,
      default: { id: "product", name: "product" },
      translate: true,
      options: [
        { id: "product", name: "product" },
        { id: "accommodation", name: "accommodation" },
      ],
    },
    amount: {
      type: "numeric",
      readOnly: true,
      function: getAmount,
      decimalPlaces: 2,
    },
    status: {
      type: "char",
      readOnly: true,
      translate: true,
      default: "draft",
    },
    folio: {
      type: "many2one",
      model: "hotel.folio",
      readOnly: true,
    },
    description: {
      type: "char",
      readOnly: true,
    },
    product: {
      type: "many2one",
      model: "product.product",
      required: true,
      readOnly: true,
    },
    quantity: {
      type: "numeric",
      default: 1,
      readOnly: true,
    },
    unit_price_w_tax: {
      type: "numeric",
      required: true,
      decimalPlaces: 2,
      readOnly: true,
    },
  },
  webtree: [
    { name: "sale_date", width: "10%" },
    { name: "product", width: "25%" },
    { name: "description", width: "15%" },
    { name: "quantity", width: "10%" },
    { name: "unit_price_w_tax", width: "20%" },
    { name: "amount", width: "15%" },
    { name: "status", width: "15%" },
  ],
  webform: [],
};

const charges = signal([]);

function WizardUpdateTaxes(props) {
  const { record } = useMainStore();
  const { reset, record: recordWizard } = useWizardStore();

  let [ctxViewUpdate, setCtxViewUpdate] = useState(ctxView);
  let [domain, setDomain] = useState([]);

  const searchTaxesOptions = async () => {
    const hotelConfig = getStorage("hotelConfig");
    const taxes = hotelConfig["taxes_auth."];
    return taxes.map((tax) => {
      return { id: tax.id, name: tax.rec_name };
    });
  };

  useEffect(() => {
    async function fetchData() {
      const options = await searchTaxesOptions();
      setCtxViewUpdate({
        ...ctxViewUpdate,
        webfields: {
          ...ctxViewUpdate.webfields,
          taxes: { type: "selection", options: options },
        },
      });
      setDomain([
        ["folio.booking", "=", record.id],
        ["invoice_line", "=", null],
      ]);
    }
    fetchData();
  }, []);

  const handleAccept = async () => {
    if (recordWizard.taxes && recordWizard.selectedRows?.size > 0) {
      const args = {
        model: "hotel.folio.charge",
        ids: Array.from(recordWizard.selectedRows.keys()),
        values: { taxes: [["add", [recordWizard.taxes.id]]] },
      };

      const { error } = await proxy.save(args);
      reset();
    }
    props.onClose(true);
  };

  return (
    <div>
      <QuickTable ctxView={ctxViewCharges} domain={domain} />
      <Form
        ctxView={ctxViewUpdate}
        record={record}
        handleButton={handleAccept}
        level="wizard"
      />
    </div>
  );
}

export default WizardUpdateTaxes;
